export const BASE_PROJECT = 'zs_mobile'
